import { Component } from '@angular/core';
import pkg from '../../../../package.json';

@Component({
  selector: 'app-version',
  standalone: true,
  template: `<pre>{{ version }}</pre>`,
})
export class VersionComponent {
  readonly version = pkg.version;
}
